"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TexasDropemOptions = void 0;
/** TexasDropemOptions.tsx
 *
 * Game Options for TexasDropem.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.TexasDropemOptions = {
    versions: [
        {
            title: "7 Card",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
        {
            title: "Cards Dealt Equal Number of Players",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.EQUAL_TO_PLAYERS,
            flavor: -1,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighLowSplitDefault],
    options: [defaultOptions_1.optionNoneDefault],
    wildcards: [defaultOptions_1.wildcardNoneDefault],
};
//# sourceMappingURL=TexasDropemOptions.js.map